import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import React from 'react';
import { PrivateAssetLibraryRoute, ReturnsDataLibraryRoute, useHasFF } from 'venn-utils';
import RedirectWithQueryParams from '../../venn-shell/src/components/RedirectWithQueryParams';
import ReturnsDataLibrary from './ReturnsDataLibrary';
import PrivateAssetLibrary from './PrivateAssetLibrary';
import { cn } from '@/lib/utils';

const Library = () => {
  const hasPrivateAnalytics = useHasFF('private_analytics');

  return (
    <div className={cn('px-[40px]')}>
      <Switch>
        <Route path={ReturnsDataLibraryRoute} component={ReturnsDataLibrary} />

        {hasPrivateAnalytics ? (
          <Route path={PrivateAssetLibraryRoute} component={PrivateAssetLibrary} />
        ) : (
          <Redirect exact from={PrivateAssetLibraryRoute} to={ReturnsDataLibraryRoute} />
        )}

        <Route path="*">
          <RedirectWithQueryParams to={ReturnsDataLibraryRoute} />
        </Route>
      </Switch>
    </div>
  );
};

export default withRouter(Library);
